import 'reset-css';
import 'swiper/css';
import './scss/index.scss';
import {useEffect} from 'react';
import {Provider} from 'react-redux';
import {persistor, store} from './store';
import {PersistGate} from 'redux-persist/integration/react';
import i18n from './i18n';
import {hooks} from './hooks';
import {getLanguageDirection, LANGUAGE_STORAGE_KEY, sanitizeLanguage} from './i18n/config';

import {StackNavigator} from './navigation/StackNavigator';

const AppShell = () => {
  const language = hooks.useAppSelector((state) => state.preferencesSlice.language);

  useEffect(() => {
    const safeLanguage = sanitizeLanguage(language);
    if (i18n.language !== safeLanguage) {
      i18n.changeLanguage(safeLanguage);
    }

    const direction = getLanguageDirection(safeLanguage);
    document.documentElement.lang = safeLanguage;
    document.documentElement.dir = direction;
    document.body.dir = direction;
    localStorage.setItem(LANGUAGE_STORAGE_KEY, safeLanguage);
  }, [language]);

  return <StackNavigator />;
};

function App() {
  return (
    <div id='app'>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppShell />
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
